import { ApplicationInsights, DistributedTracingModes } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

import { applicationInsightsInstrumentationKey } from 'config';

/**
 * Boolean value that denotes whether or no tracking should take place.
 */
const trackingIsActive = Boolean(applicationInsightsInstrumentationKey
  && (process.env.NODE_ENV === 'production'));

const reactPlugin = new ReactPlugin();

const appInsights = () => new ApplicationInsights({
  config: {
    instrumentationKey: applicationInsightsInstrumentationKey,
    distributedTracingMode: DistributedTracingModes.W3C,
    enableCorsCorrelation: true,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { },
    },
  },
});

/**
 * Helper function to ensure all components are wrapped the same.
 * @param {Component} component the component being wrapped
 * @param {String} componentName the name of the component, required if the component is pure
 */
const withTracking = (
  component,
  componentName,
) => {
  if (trackingIsActive) {
    return withAITracking(reactPlugin, component, componentName);
  }
  return component;
};

export {
  reactPlugin,
  appInsights,
  withTracking,
  trackingIsActive,
};



// WEBPACK FOOTER //
// ./src/insights/index.js